import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-eb276cec")
const _hoisted_1 = {
  noPad: "",
  class: "relative mb-2 overflow-auto"
}
const _hoisted_2 = { class: "mt-0 mb-[12px]flex justify-between" }
const _hoisted_3 = { class: "summary price" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "summary-stat" }, null, -1)
const _hoisted_5 = { class: "my-0.5 flex justify-between" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "summary" }, "Minimum Received", -1)
const _hoisted_7 = { class: "summary-stat" }
const _hoisted_8 = { class: "my-0.5 flex justify-between" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "summary" }, "Price Impact", -1)
const _hoisted_10 = { class: "slippage" }
const _hoisted_11 = { class: "my-0.5 flex justify-between" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "summary" }, "Liquidity Provider Fee", -1)
const _hoisted_13 = { class: "summary-stat" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "my-0.5 flex justify-between" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "summary" }, "Routed Via"),
  /*#__PURE__*/_createElementVNode("div", { class: "routed" }, "Standard AMM")
], -1)
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, " Price: " + _toDisplayString(_ctx.trading.exactIn.value
              ? _ctx.trading.effectivePriceMessage.value.tokenIn
              : _ctx.trading.effectivePriceMessage.value.tokenOut), 1),
        _hoisted_4
      ]),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.summary.totalWithSlippage), 1)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.fNum2(_ctx.trading.sor.priceImpact.value, _ctx.FNumFormats.percent)), 1)
      ]),
      _createElementVNode("div", _hoisted_11, [
        _hoisted_12,
        _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.summary.tradeFees), 1)
      ]),
      _hoisted_14
    ])
  ]))
}